import {Retailer} from './retailer';

export enum BarcodeType {
  OWNER_ACCOUNT = 'OWNER_ACCOUNT',
  THIRD_PARTY_ACCOUNT = 'THIRD_PARTY_ACCOUNT'
}

export enum BarcodeStatus {
  NEW= 'NEW',
  PENDING= 'PENDING',
  CONSUMED= 'CONSUMED',
  VOIDED= 'VOIDED',
  EXPIRED= 'EXPIRED',
  CANCELLED= 'CANCELLED',
  DECLINED= 'DECLINED'
}

export interface IBarcode {
  id: string;
  expirationDate: Date | null;
  lastChangedDate: Date | null;
  creationDate: Date | null;
  type: string;
  status: BarcodeStatus;
  retailer: Retailer;
  amount: number;
  targetFirstName: string | null;
  targetLastName: string | null;
  targetReference: string | null;
  loadType: BarcodeType;
  retailerKey: number | null;
}
